import { gql, useQuery } from "@apollo/client"
import { Company } from "@oysterhr/schema"

export const SCALE_SUBSCRIPTION_FOR_COMPANY_QUERY = gql`
  query ScaleSubscriptionForCompany($companyId: ID!) {
    company(companyId: $companyId) {
      id
      activeOrPendingScaleSubscription {
        id
        startsOn
        billingCycle
        name
        numberOfSeats
        availableSeatsCount
        reservedSeatsCount
        takenSeatsCount
        pendingSeatsCount
        isActive
        hasAvailableSeats
        annualPrice {
          subunit
          currencyCode
        }
        expiresOn
        pricePerSeat {
          subunit
          currencyCode
        }
      }
    }
  }
`
export const useScaleSubscriptionForCompany = (companyId?: string) =>
  useQuery<{ company: Company }>(SCALE_SUBSCRIPTION_FOR_COMPANY_QUERY, {
    variables: {
      companyId: `Company:${companyId}`,
    },
    skip: !companyId,
    fetchPolicy: "network-only",
  })
